module.exports = __webpack_public_path__ + "img/720.dc3bb112.svg";